export const ENABLE_ZONE_DEBUGGING = false;
export const SHOW_SOCIAL_LINKS = false;
export const TILE_SIZE = 64;
export const TILED_COLLISION_LAYER_ALPHA = 0;
export const TEXT_SPEED = Object.freeze({
  SLOW: 50,
  MEDIUM: 30,
  FAST: 15,
});
export const MENU_COLOR = Object.freeze({
  1: {
    main: 0x32454c,
    border: 0x6d9aa8,
  },
  2: {
    main: 0x324c3a,
    border: 0x6da87d,
  },
  3: {
    main: 0x38324c,
    border: 0x796da8,
  },
});
